import { ServerConfig } from "./server-config";

// Server config has separate urls hosted on dedicated subdomains for widget & dashboard.
// This should be fixed also.
const getConfigAbsoluteUrlPath = () =>
  location.pathname.startsWith("/dashboard") ? "/dashboard/config" : "/config";

// Hack moved here from fore-preloader, it loads the fore quicker
// Should be removed and done in asynnc way, but currently a lot of deps uses it.
const getServerConfigSynchronous = (): ServerConfig | undefined => {
  const request = new XMLHttpRequest();
  request.open("GET", getConfigAbsoluteUrlPath(), false); // `false` makes the request synchronous
  /* tslint:disable-next-line:no-null-keyword */
  request.send(null);

  if (request.status === 200) {
    return JSON.parse(request.responseText) as ServerConfig;
  }
  return undefined;
};

// used only by jest
type WindowWithServerConfig = typeof window & { CLOSER_CONFIG: ServerConfig | undefined };

// used only by jest
const windowServerConfig = (window as WindowWithServerConfig).CLOSER_CONFIG;

const serverConfig = windowServerConfig ? windowServerConfig : getServerConfigSynchronous();

if (!serverConfig) {
  throw new Error("Server config is not present");
}

const services: ServerConfig = serverConfig;
export const config = {
  services
};

export type Config = typeof config;
